module.exports = __webpack_public_path__ + "img/title-bg.37f6713b.png";